import { COMPONENTS_TYPES } from '../../../../componentTypes';
import RestorePassword from '@monorepo/auth/components/RestorePassword';
import RestorePassword1StepFinish from '@monorepo/auth/components/FirstStepFinish';
import RestorePasswordSetNew from '@monorepo/auth/components/SetNew';
import PersonalOfficeMenu from '@monorepo/auth/components/PersonalOfficeMenu';
import Login from '@monorepo/auth/components/Login';
import PageHeader from '@monorepo/auth/components/PageHeader';
import PersonalInfo from '@monorepo/auth/components/PersonalInfo';
import ChangePassword from '@monorepo/auth/components/ChangePassword';
import UserContactsListFO from '@monorepo/auth/components/UserContactsListFO';
import UserScrollMenu from '@monorepo/auth/common/UserScrollMenu';
import AddContactPersonFO from '@monorepo/auth/components/AddContactPersonFO';
import UserLocations from '@monorepo/auth/components/UserLocations';
import AddLocation from '@monorepo/auth/components/AddLocation';
import UserMerchandisersListFO from '@monorepo/auth/components/UserMerchandisersListFO';
import UserAddMerchandiser from '@monorepo/auth/components/UserAddMerchandiser';
import UserDocumentsFO from '@monorepo/auth/components/UserDocumentsFO';
import UserSubscriptions from '@monorepo/auth/components/UserSubscriptions';
import PrivacyPolicy from '@monorepo/auth/components/PrivacyPolicy';
import UserAgreement from '@monorepo/auth/components/UserAgreement';
import TemporaryUserRegister from '@monorepo/auth/components/TemporaryUserRegister';
import ApiTokens from '@monorepo/auth/components/ApiTokens';

import Banner from '@monorepo/ui-kit/components/Banner';

import DropdownFilters from '@monorepo/orders/components/DropdownFilters';
import OrdersListV2 from '@monorepo/orders/components/OrdersListV2';
import TypesFilter from '@monorepo/orders/components/TypesFilter';
import OrderDetails from '@monorepo/orders/components/OrderDetails';

import BackHeader from '@monorepo/common/components/BackHeader';
import RedirectComponent from '@monorepo/common/components/RedirectComponent';

import ContactsList from '@monorepo/contacts/components/ContactsList';
import StatusFilter from '@monorepo/contacts/components/StatusFilter';
import ContactDetails from '@monorepo/contacts/components/ContactDetails';
import ContactDetailsHeader from '@monorepo/contacts/components/ContactDetailsHeader';

import OffersByOrder from '@monorepo/offers/components/OffersByOrder';
import OffersByOrderV2 from '@monorepo/offers/components/OffersByOrderV2';
import OffersList from '@monorepo/offers/components/OffersList';
import OffersDropdownFilters from '@monorepo/offers/components/DropdownFilters';
import OffersTypesFilter from '@monorepo/offers/components/TypesFilter';

import DealsList from '@monorepo/deals/components/DealsList';
import DealsList2 from '@monorepo/deals/components/DealsListV2';
import DealsListByFarmer from '@monorepo/deals/components/DealsListByFarmer';
import DealsTypesFilter from '@monorepo/deals/components/TypesFilter';
import DealsDropdownFilters from '@monorepo/deals/components/DropdownFilters';
import DealDetails from '@monorepo/deals/components/DealDetails';
import OffersByDeal from '@monorepo/deals/components/OffersByDeal';
import DealHeader from '@monorepo/deals/components/DealHeader';

import FastDealsList from '@monorepo/fast-deals/components/FastDealsList';
import FastDealsDropdownFilters from '@monorepo/fast-deals/components/DropdownFilters';
import FastDealsTypesFilter from '@monorepo/fast-deals/components/TypesFilter';

import PricingTypeFilter from '@monorepo/pricing/components/TypesFilter';
import PricingSideBarFilter from '@monorepo/pricing/components/SideBarFilter';
import PricingDropdownFilters from '@monorepo/pricing/components/DropdownFilters';

import AddClientForm from '@monorepo/counterparties/components/AddClientForm';
import ClientsFilter from '@monorepo/counterparties/components/ClientsFilter';
import ClientsList from '@monorepo/counterparties/components/ClientsList';
import GoBackFormHeader from '@monorepo/counterparties/components/GoBackFormHeader';
import UpdateClientForm from '@monorepo/counterparties/components/UpdateClientForm';

import ReferralsDealsList from '@monorepo/referrals/components/ReferralsDealsList';
import ReferralsFastDealsList from '@monorepo/referrals/components/ReferralsFastDealsList';
import ReferralsList from '@monorepo/referrals/components/ReferralsList';

import PriceList from '@monorepo/pricing/components/PriceList';
import PricingChosenFilters from '@monorepo/pricing/components/ChosenFilters';
import SideButton from '@monorepo/pricing/components/SideButton';

import HeaderUserMenu from '@monorepo/auth/components/HeaderUserMenu';
import Logo from '../Logo';
import LanguageSwitcher from '@monorepo/common/components/LanguageSwitcher';
import HeaderSearch from '@monorepo/common/components/HeaderSearch';
import LinkChat from '@monorepo/auth/components/LinkChat';
import HeaderNavMenu from '@monorepo/ui-kit/components/HeaderNavMenu';

const componentsMap = {
  [COMPONENTS_TYPES.HEADER_NAV_MENU]: HeaderNavMenu,
  [COMPONENTS_TYPES.PRICING_SIDE_BUTTON]: SideButton,
  [COMPONENTS_TYPES.LOGIN]: Login,
  [COMPONENTS_TYPES.TEMPOPARY_USER_REGISTER]: TemporaryUserRegister,
  [COMPONENTS_TYPES.RESTORE_PASSWORD_LOGIN]: RestorePassword,
  [COMPONENTS_TYPES.RESTORE_PASSWORD_CHECK_EMAIL]: RestorePassword1StepFinish,
  [COMPONENTS_TYPES.RESTORE_PASSWORD_SET_NEW]: RestorePasswordSetNew,
  [COMPONENTS_TYPES.CHANGE_PASSWORD]: ChangePassword,
  [COMPONENTS_TYPES.PERSONAL_OFFICE_MENU]: PersonalOfficeMenu,
  [COMPONENTS_TYPES.PAGE_HEADER]: PageHeader,
  [COMPONENTS_TYPES.PERSONAL_INFO]: PersonalInfo,
  [COMPONENTS_TYPES.PERSONAL_INFO_CONTACTS_FO]: UserContactsListFO,
  [COMPONENTS_TYPES.USER_SCROLL_MENU]: UserScrollMenu,
  [COMPONENTS_TYPES.ADD_CONTACT_PERSON_FO]: AddContactPersonFO,
  [COMPONENTS_TYPES.USER_LOCATIONS]: UserLocations,
  [COMPONENTS_TYPES.USER_ADD_LOCATION]: AddLocation,
  [COMPONENTS_TYPES.USER_MERCHANDISERS_LIST]: UserMerchandisersListFO,
  [COMPONENTS_TYPES.USER_ADD_MERCHANDISER]: UserAddMerchandiser,
  [COMPONENTS_TYPES.USER_DOCUMENTS_FO]: UserDocumentsFO,
  [COMPONENTS_TYPES.USER_SUBSCRIPTIONS]: UserSubscriptions,
  [COMPONENTS_TYPES.API_TOKENS]: ApiTokens,
  [COMPONENTS_TYPES.PRIVACY_POLICY]: PrivacyPolicy,
  [COMPONENTS_TYPES.USER_AGREEMENT]: UserAgreement,

  // Common
  [COMPONENTS_TYPES.BANNER]: Banner,
  [COMPONENTS_TYPES.BANNER]: Banner,
  [COMPONENTS_TYPES.BACK_HEADER]: BackHeader,
  [COMPONENTS_TYPES.REDIRECT]: RedirectComponent,
  [COMPONENTS_TYPES.PAGE_404]: undefined, // Не найден в импортах
  [COMPONENTS_TYPES.DEVICE_DETECTOR]: undefined, // Не найден в импортах
  [COMPONENTS_TYPES.HEADER_USER_MENU]: HeaderUserMenu,
  [COMPONENTS_TYPES.HEADER_SEARCH]: HeaderSearch,
  [COMPONENTS_TYPES.LINK_CHAT]: LinkChat,
  [COMPONENTS_TYPES.LANGUAGE_SWITCHER]: LanguageSwitcher,

  // Orders
  [COMPONENTS_TYPES.ORDERS_TYPES_FILTER]: TypesFilter,
  [COMPONENTS_TYPES.ORDERS_LIST2]: OrdersListV2,
  [COMPONENTS_TYPES.ORDERS_DROPDOWN_FILTERS]: DropdownFilters,
  [COMPONENTS_TYPES.ORDER_DETAILS]: OrderDetails,

  // Offers
  [COMPONENTS_TYPES.OFFERS_LIST]: OffersList,
  [COMPONENTS_TYPES.OFFERS_TYPES_FILTER]: OffersTypesFilter,
  [COMPONENTS_TYPES.OFFERS_DROPDOWN_FILTERS]: OffersDropdownFilters,
  [COMPONENTS_TYPES.OFFERS_BY_ORDER]: OffersByOrder,
  [COMPONENTS_TYPES.OFFERS_BY_ORDERV2]: OffersByOrderV2,

  // Deals
  [COMPONENTS_TYPES.DEALS_LIST]: DealsList,
  [COMPONENTS_TYPES.DEALS_LIST2]: DealsList2,
  [COMPONENTS_TYPES.DEALS_TYPES_FILTER]: DealsTypesFilter,
  [COMPONENTS_TYPES.DEALS_DROPDOWN_FILTERS]: DealsDropdownFilters,
  [COMPONENTS_TYPES.DEALS_LIST_BY_FARMER]: DealsListByFarmer,
  [COMPONENTS_TYPES.DEAL_DETAILS]: DealDetails,
  [COMPONENTS_TYPES.OFFERS_BY_DEAL]: OffersByDeal,
  [COMPONENTS_TYPES.DEAL_HEADER]: DealHeader,

  // Fast Deals
  [COMPONENTS_TYPES.FAST_DEALS_LIST]: FastDealsList,
  [COMPONENTS_TYPES.FAST_DEALS_DROPDOWN_FILTERS]: FastDealsDropdownFilters,
  [COMPONENTS_TYPES.FAST_DEALS_TYPES_FILTER]: FastDealsTypesFilter,

  // Contacts
  [COMPONENTS_TYPES.CONTACTS_LIST]: ContactsList,
  [COMPONENTS_TYPES.CONTACTS_TOP_FILTER]: StatusFilter,
  [COMPONENTS_TYPES.CONTACT_DETAILS]: ContactDetails,
  [COMPONENTS_TYPES.CONTACT_DETAILS_HEADER]: ContactDetailsHeader,

  // Pricing
  [COMPONENTS_TYPES.PRICE_LIST]: PriceList,
  [COMPONENTS_TYPES.PRICING_TYPES_FILTER]: PricingTypeFilter,
  [COMPONENTS_TYPES.PRICING_CHOSEN_FILTERS]: PricingChosenFilters,
  [COMPONENTS_TYPES.PRICING_SIDEBAR_FILTER]: PricingSideBarFilter,
  [COMPONENTS_TYPES.PRICING_DROPDOWN_FILTERS]: PricingDropdownFilters,

  // Counterparties (Clients)
  [COMPONENTS_TYPES.CLIENTS_LIST]: ClientsList,
  [COMPONENTS_TYPES.GO_BACK_CLIENT_FORM_HEADER]: GoBackFormHeader,
  [COMPONENTS_TYPES.ADD_CLIENT_FORM]: AddClientForm,
  [COMPONENTS_TYPES.UDPDATE_CLIENT_FORM]: UpdateClientForm,
  [COMPONENTS_TYPES.CLIENTS_FILTER]: ClientsFilter,

  // Referrals
  [COMPONENTS_TYPES.REFERRALS_LIST]: ReferralsList,
  [COMPONENTS_TYPES.REFERRALS_DEALS_LIST]: ReferralsDealsList,
  [COMPONENTS_TYPES.REFERRALS_FAST_DEALS_LIST]: ReferralsFastDealsList,
  [COMPONENTS_TYPES.LOGO]: Logo
};

export default componentsMap;
